import {call, put, takeLatest} from "redux-saga/effects";
import {enrichWithArtistIdListForNoAdmin} from "../common/enrichWithArtistIdListForNoAdmin";
import {extractDataFromResponse} from "../../../saga-utils/httpInterceptorWrapper";
import {getProjektListe} from "../../../../api/projektApi";
import {
    LOAD_PROJEKT_LIST_DATA,
    loadProjektListDataFailureAction,
    loadProjektListDataSuccessAction
} from "../../listActions";
import {emitNotificationAction} from "../../../notification/notificationAction";
import {createErrorNotification} from "../../../../models/notification";
import i18next from "i18next";
import {i18_EDITPROJEKT} from "../../../../i18nReferences";
import { standardizeListParametersOfParameterObject } from "../../../utils/urlHelper";

function* processLoadProjektListData({payload}) {
    try {
        const parameters = yield enrichWithArtistIdListForNoAdmin(payload.parameters)
        const standardParameters = standardizeListParametersOfParameterObject(parameters)
        const projekte = extractDataFromResponse(yield call(getProjektListe, {parameters: standardParameters}))
        yield put(loadProjektListDataSuccessAction(projekte))
    } catch (err) {
        yield put(emitNotificationAction(createErrorNotification(i18next.t('LIST.LOAD_PROJEKT_LIST_DATA_FAILED_INFO', {ns: i18_EDITPROJEKT}), 'loadListData')))
        yield put(loadProjektListDataFailureAction())
        console.log(err)
    }
}

export function* watchLoadProjektListData() {
    yield takeLatest(LOAD_PROJEKT_LIST_DATA, processLoadProjektListData)
}